module.exports = __webpack_public_path__ + "static/media/power-off.7d204314.svg";